import { render } from "./AuxiliaryAccountingBalance.vue?vue&type=template&id=2f944fd6&scoped=true"
import script from "./AuxiliaryAccountingBalance.vue?vue&type=script&lang=js"
export * from "./AuxiliaryAccountingBalance.vue?vue&type=script&lang=js"

import "./AuxiliaryAccountingBalance.vue?vue&type=style&index=0&id=2f944fd6&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f944fd6"]])

export default __exports__